import { Box, Divider as MuiDivider } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { spacing } from "@mui/system";
import axios from "axios";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import styled from "styled-components";
import StandardHeader from "../../components/global/StandardHeader";
import { LeftSidebar as NavFrame } from "layout-blueprints";
import ARTable from "../../modules/accounting/components/AccountReceivablesTable";
import { logout } from "../../modules/user/api/actions";
import {
  getAllPropertyPreviews,
  getAnalyticalData,
} from "../../modules/apl/api/actions";
import SimpleStatCard from "../../components/cards/SimpleStatCard";
import AgingTable from "../../modules/accounting/components/AgingTable";
// components
import AcumaticaActions from "./components/AcumaticaActions";
import AcumaticaStatus from "./components/AcumaticaStatus";
import CashIncome from "./components/CashIncome";
import PaymentsByType from "./components/PaymentsByType";
import { formatMoney } from "../../setup/helpers";

const Divider = styled(MuiDivider)(spacing);

const AccountingPage = (props) => {
  const dispatch = useDispatch();

  const [value, setValue] = React.useState(0); // used for tabs

  // Acumatica Actions and Status State
  let [acumaticaDate, setAcumaticaDate] = useState("");
  let [acumaticaConnected, setAcumaticaConnected] = useState(false);
  let [acumaticaStatusLoading, setAcumaticaStatusLoading] = useState(true);
  let [batchesRan, setBatchesRan] = useState([]);
  let [incomeStatementsRan, setIncomeStatementsRan] = useState([]);

  // report data
  let [paymentsInfo, setPaymentsInfo] = useState([]);
  let [paymentsInfoLoading, setPaymentsInfoLoading] = useState(true);

  const [utilityValue, setUtilityValue] = useState("1"); // 1 = APL, 2 = CCOS
  async function getPaymentsByDate() {
    try {
      setPaymentsInfoLoading(true);
      let headers = {
        "x-access-token": localStorage.getItem("token"),
      };

      let data = await axios.put(
        "/report/call",
        {
          function: "GetPaymentsByDate",
          params: [moment().format("YYYY-MM-DD")],
        },
        { headers }
      );

      setPaymentsInfoLoading(false);
      setPaymentsInfo(data.data[0]);
    } catch (err) {
      setPaymentsInfoLoading(false);
    }
  }
  useEffect(() => {
    if(props.user.details.accounting || props.user.details.isSuperUser){
    async function testAcumaticaStatus() {
      try {
        setAcumaticaStatusLoading(true);
        let headers = {
          "x-access-token": localStorage.getItem("token"),
        };

        let res = await axios.get("/run-acumatica-status", { headers });

        if (!res) throw new Error("Fail.");

        setAcumaticaConnected(true);

        setAcumaticaStatusLoading(false);
      } catch (err) {
        setAcumaticaStatusLoading(false);
        setAcumaticaConnected(false);
      }
    }

   

    testAcumaticaStatus();
    getPaymentsByDate();
    document.title = "Ubil+ Accounting Dashboard";
    props.getAllPropertyPreviews();
    props.getAnalyticalData(props.apl.analyticRange);
    }
  }, [props.user]);

  // change tabs
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div {...other}>{value === index && <Box p={3}>{children}</Box>}</div>
    );
  }

  return (
    <NavFrame page={"Accounting"}>
      <StandardHeader title="Accounting" />
      <Divider className="mb-3 mt-3" />
      {props.user.details.accounting || props.user.details.administration || props.user.details.isSuperUser ? (
      <Box sx={{ 
        width: '100%',
        maxWidth: '100%',
        mx: 'auto',
        px: { xs: 2, sm: 3 },
        py: { xs: 2, sm: 3 }
      }}>
        <AppBar 
          position="static" 
          color="primary"
          sx={{ 
            borderRadius: 1,
            mb: { xs: 2, sm: 3 }
          }}
        >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="accounting tabs"
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
            >
              <Tab label="Overview" />
              <Tab label="Today's Payments" />
              <Tab label="Acumatica" />
              <Tab label="Cash Income" />
              <Tab label="Aging" />
              <Tab label="Receipts" />
            </Tabs>
          </AppBar>

        {/* Overview Tab */}
        <TabPanel value={value} index={0}>
          <Box sx={{ 
            display: 'flex', 
            flexWrap: 'wrap', 
            gap: 3,
            mb: 4
          }}>
            <Box sx={{ 
              flex: { 
                xs: '1 1 100%', 
                sm: '1 1 calc(50% - 12px)', 
                md: '1 1 calc(50% - 12px)' 
              },
              minWidth: 0 
            }}>
              <SimpleStatCard
                title="Cash Received"
                amount={
                  props.apl.analyticSummary?.paymentsSummary
                    ? formatMoney(
                      props.apl.analyticSummary.paymentsSummary.summary
                        .amountPaid
                    ) || 0
                    : "N/A"
                }
                chip={props.apl.analyticRange}
                isLoaded={
                  !props.apl.isLoading && !props.apl.analyticSummaryIsLoading
                }
              />
            </Box>
            <Box sx={{ 
              flex: { 
                xs: '1 1 100%', 
                sm: '1 1 calc(50% - 12px)', 
                md: '1 1 calc(50% - 12px)' 
              },
              minWidth: 0 
            }}>
              <SimpleStatCard
                title="Total Billed"
                amount={
                  props.apl.analyticSummary?.billingSummary
                    ? formatMoney(
                      props.apl.analyticSummary?.billingSummary.summary
                        .totalBilled
                    ) || 0
                    : "N/A"
                }
                chip={props.apl.analyticRange}
                isLoaded={
                  !props.apl.isLoading && !props.apl.analyticSummaryIsLoading
                }
              />
            </Box>
          </Box>
        </TabPanel>

        {/* Today's Payments Tab */}
        <TabPanel value={value} index={1}>
          <Box sx={{ width: '100%', p: 2 }}>
            <PaymentsByType
              paymentsInfo={paymentsInfo}
              paymentsInfoLoading={paymentsInfoLoading}
            />
          </Box>
        </TabPanel>

        {/* Acumatica Tab */}
        <TabPanel value={value} index={2}>
          <Box sx={{ 
            width: '100%',
            maxWidth: 800,
            mx: 'auto',
            p: 2,
            display: 'flex',
            flexDirection: 'column',
            gap: 3
          }}>
              <AcumaticaActions
                acumaticaDate={acumaticaDate}
                setAcumaticaDate={setAcumaticaDate}
                utilityValue={utilityValue}
                setUtilityValue={setUtilityValue}
                acumaticaConnected={acumaticaConnected}
                batchesRan={batchesRan}
                setBatchesRan={setBatchesRan}
              />
            <AcumaticaStatus
              acumaticaConnected={acumaticaConnected}
              acumaticaStatusLoading={acumaticaStatusLoading}
            />
          </Box>
        </TabPanel>

        {/* Cash Income Tab */}
        <TabPanel value={value} index={3}>
          <Box sx={{ width: '100%', p: 2 }}>
              <CashIncome
                dispatch={dispatch}
                incomeStatementsRan={incomeStatementsRan}
                setIncomeStatementsRan={setIncomeStatementsRan}
              />
          </Box>
        </TabPanel>

        {/* Aging Tab */}
        <TabPanel value={value} index={4}>
          <Box sx={{ width: '100%', overflow: 'auto' }}>
            <AgingTable />
          </Box>
        </TabPanel>

        {/* Receipts Tab */}
        <TabPanel value={value} index={5}>
          <Box sx={{ width: '100%', overflow: 'auto' }}>
            <ARTable />
          </Box>
        </TabPanel>


      </Box>
        ) :
        (<h3>You do not have accounting privilages</h3> )}
    </NavFrame >
  );
};

// Component Properties
AccountingPage.propTypes = {
  user: PropTypes.object.isRequired,
  apl: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired,
  getAnalyticalData: PropTypes.func.isRequired,
  getAllPropertyPreviews: PropTypes.func.isRequired,
};

// Component State
function AccountingPageState(state) {
  return {
    user: state.user,
    apl: state.apl,
  };
}
export default connect(AccountingPageState, {
  logout,
  getAnalyticalData,
  getAllPropertyPreviews,
})(AccountingPage);
